"use client";

import { motion } from "framer-motion";

interface LoadingAnimationProps {
  progress: number;
}

export function LoadingAnimation({ progress }: LoadingAnimationProps) {
  const steps = [
    { label: "Finding property details", target: 30 },
    { label: "Loading images", target: 60 },
    { label: "Analyzing listing data", target: 85 },
    { label: "Almost there", target: 95 },
  ];

  const currentStep = steps.findIndex((step) => progress <= step.target);

  return (
    <div className="space-y-4">
      <div className="relative h-2 bg-gray-100 rounded-full overflow-hidden">
        <motion.div
          className="absolute left-0 top-0 h-full bg-blue-600"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.5 }}
        />
      </div>

      <div className="flex justify-between">
        {steps.map((step, index) => (
          <motion.div
            key={step.label}
            initial={{ opacity: 0.5 }}
            animate={{
              opacity: index === currentStep ? 1 : 0.5,
              scale: index === currentStep ? 1.05 : 1,
            }}
            className="text-sm text-gray-600"
          >
            {step.label}
          </motion.div>
        ))}
      </div>
    </div>
  );
}
